module.exports = __webpack_public_path__ + "img/floorboard-desktop-layers.7de68b6d.jpg";